export const GRAPHQL_ERROR_CODE = {
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_SERVER_ERROR: 'INTERNAL SERVER ERROR',
  INVALID_TOKEN: 'INVALID TOKEN',
  NOT_FOUND: 'NOT FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
} as const

export const DEFAULT_POOLING_INTERVAL: number = 5_000 // [ms]
export const MAX_SAFE_GQL_INTEGER = 2_147_483_647
